import React, { Component } from "react";
import Error from "./Error";

class Error404 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Error statusCode="404" message="Sorry, Page Not Found" />
      </React.Fragment>
    );
  }
}

export default Error404;
